namespace TabAurous.HR {
    export interface AttendanceDetailsRow {
        DetailId?: number;
        TransId?: number;
        EmployeeId?: number;
        EmployeeName?: string;
        EmployeeCode?: string;
        TransDate?: string;
        Present?: boolean;
        Absent?: boolean;
        HalfDay?: boolean;
        OnLeave?: boolean;
    }

    export namespace AttendanceDetailsRow {
        export const idProperty = 'DetailId';
        export const localTextPrefix = 'HR.AttendanceDetails';
        export const deletePermission = 'HR:Attendance:Delete';
        export const insertPermission = 'HR:Attendance:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:Attendance:Edit';

        export declare const enum Fields {
            DetailId = "DetailId",
            TransId = "TransId",
            EmployeeId = "EmployeeId",
            EmployeeName = "EmployeeName",
            EmployeeCode = "EmployeeCode",
            TransDate = "TransDate",
            Present = "Present",
            Absent = "Absent",
            HalfDay = "HalfDay",
            OnLeave = "OnLeave"
        }
    }
}
